module.exports = __webpack_public_path__ + "img/shorts.f8dd6857.svg";